/*
 * @Descripttion: 视频标签相关
 * @version:
 * @Author: Mrak
 * @Date: 2020-05-24 14:14:20
 * @LastEditors: Mark
 * @LastEditTime: 2020-05-25 16:07:04
 */

import { GetClassIfy, GetActList, GetPlanList } from '@/services/uploads'

import { setStoreFormat } from '@/utils/mUtil'

const state = () => ({
  classify: [],
  activeList: [],
  planList: [],
})

// getters
const getters = {
  classify: (state: any) => state.classify,
  activeList: (state: any) => state.activeList,
  planList: (state: any) => state.planList,
}

// actions
const actions = {
  async fetchClassIfy({ commit, state }: any) {
    try {
      const { data } = await GetClassIfy()
      const list: Array<object> = []
      if (data) {
        for (const el in data) {
          list.push({
            value: el,
            label: el,
          })
        }
      }
      commit('setClassIfy', list)
    } catch (error) {
      console.log(error)
    }
  },

  async fetchActiveList({ commit, state }: any) {
    try {
      const { data } = await GetActList()

      commit('setActiveList', setStoreFormat(data))
    } catch (error) {
      console.log(error)
    }
  },

  async fetchPlanList({ commit, state }: any) {
    try {
      const { data } = await GetPlanList()
      // const { data } = []
      commit('setPlanList', setStoreFormat(data))
    } catch (error) {
      console.log(error)
    }
  },

  async fetchVideoTag({ dispatch, commit, state }: any) {
    try {
      dispatch('fetchClassIfy')
      dispatch('fetchActiveList')
      dispatch('fetchPlanList')
    } catch (error) {
      console.log(error)
    }
  },
}

// mutations
const mutations = {
  setClassIfy(state: any, classify: any) {
    state.classify = classify
  },

  setActiveList(state: any, activeList: any) {
    state.activeList = activeList
  },

  setPlanList(state: any, planList: any) {
    state.planList = planList
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
